export default __webpack_public_path__ + "static/media/slide3.3681949e.jpg";